<template>
  <nav class="breadcrumb">
    <ul>
      <li>
        <router-link
          to=""
          @click="$emit('click')"
          :class="['breadcrumb-link', companyName ? 'breadcrumb-link--active' : '']"
        >
          Grupos
        </router-link>
      </li>
      <li v-if="companyName">
        <span>&gt;</span>
      </li>
      <li v-if="companyName">
        <span class="company-name">{{ companyName }}</span>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { defineProps } from 'vue'
defineProps<{ companyName?: string }>()
defineEmits<{
  click: []
}>()
</script>

<style scoped>
.breadcrumb {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2rem;
  color: #888;
  margin-top: 30px;
  margin-left: 45px;
}
.breadcrumb ul {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  margin: 0;
}
.breadcrumb li {
  display: flex;
  align-items: center;
}
.breadcrumb-link {
  color: #888;
  text-decoration: none;
  transition: color 0.2s;
}
.breadcrumb-link--active {
  color: #003896;
}
.company-name {
  color: #888;
  font-weight: 600;
}
</style>
